// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__s73rA","error":"Textarea_error__PUs0O","readonly":"Textarea_readonly__29E-j","disabled":"Textarea_disabled__1KGED"};